export const shouldAutoOpenChanges = (previousCount: number, count: number, isSidebarOpen: boolean): boolean => {
  return previousCount === 0 && count > 0 && !isSidebarOpen;
};
